import httpClient from "@/api/http-client";
import axios, { AxiosResponse } from "axios";

interface ConstantFilesUrl {
  termsFile: string;
}

const BASE_URL = `${httpClient.defaults.baseURL}`;
const ENDPOINT = `${BASE_URL}/configuracion`;

class ConfigFilesService {
  updateTermFile(file: File): Promise<void | AxiosResponse> {
    const formData = new FormData();
    formData.append("file", file);

    return axios.put(`${ENDPOINT}/terms-file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  getConstantFiles(): ConstantFilesUrl {
    return {
      termsFile: `${BASE_URL}/static/pdfs/TERMS_PAYMENT.pdf`
    };
  }
}

export default new ConfigFilesService();
